import {defineComponent} from "vue";
import {ErrorHandlerQueue} from "@/error/ErrorHandlerQueue";
import {DpExceptionsErrorHandler} from "@/error/handlers/DpExceptionsErrorHandler";
import {AxiosErrorHandler} from "@/error/handlers/AxiosErrorHandler";
import {UIStateDto} from "@/dtos/UIStateDto";
import {AbilityContext} from "@/context/AbilityContext";
import {AuthContext} from "@/context/AuthContext";

export const ComponentMixin = defineComponent({
    data() {
        return {
            componentUI: UIStateDto.createWithDefaults(),
        };
    },
    computed: {
        AbilityContext() {
            return AbilityContext;
        },
        AuthContext() {
            return AuthContext;
        }
    },
    methods: {
        async initialize(): Promise<void> {
            if (!this.hasAuthorization()) {
                alert('Not authorized for this action.');
                return;
            }
            this.componentUI.clearError().setNotReady();
            try {
                await this.doInitialize();
                await this.doReload();
            } catch (exceptions: any) {
                this.setExceptions(exceptions);
            } finally {
                this.componentUI.setReady();
            }
        },
        async reloadContent(): Promise<void> {
            if (!this.hasAuthorization()) {
                alert('Not authorized for this action.');
                return;
            }
            this.componentUI.clearError().setNotReady();
            try {
                await this.doReload();
            } catch (exceptions: any) {
                this.setExceptions(exceptions);
            } finally {
                this.componentUI.setReady();
            }
        },
        setExceptions(exceptions: unknown): void {
            ErrorHandlerQueue.create()
                .add(DpExceptionsErrorHandler.createWithDefaultUIStateBehavior(this.componentUI as UIStateDto))
                .add(AxiosErrorHandler.createWithDefaultUIStateBehavior(this.componentUI as UIStateDto))
                .catch(exceptions, true);
            window.scrollTo(0, 0);
        },
        async doReload(): Promise<void> {
            // Default implementation empty.  Override if component needs to retrieve data based on its properties' values
        },
        async doInitialize(): Promise<void> {
            throw new Error('doInitialize must be implemented');
        },
        hasAuthorization(): boolean {
            return true;
        },
    },
});
